import { useContext } from "react";
import { ThemeContext } from "styled-components/native";

import { Theme } from "../types";

const useTheme = (): Theme => useContext(ThemeContext);

export default useTheme;
